<template>
	<div class="unknown-numen" v-html="this.oubliPersonnelHtml"></div>
</template>
<script>
  export default {
    name: 'unknown-numen',
    props: {
    },
    data: () => ({
    }),
    methods: {
    },
	computed: {
		oubliPersonnelHtml(){
			return this.$store.state.appinfo.appData ? this.$store.state.appinfo.appData.oubliPersonnelHtml : "Chargement en cours...";
		}
	}
  }
</script>
<style scoped>
  .unknown-numen p { margin-bottom: 0; font-weight: 600;}
</style>